"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('space');
const renderItems = (children, size, direction) => {
    let itemStyle = undefined;
    if (typeof size === 'number') {
        itemStyle =
            direction === 'vertical'
                ? {
                    marginBottom: size,
                }
                : {
                    marginRight: size,
                };
    }
    const items = [];
    React.Children.forEach(children, (child, index) => {
        const itemCn = classnames_1.default(`${prefixCls}-item`, {
            [`${prefixCls}-${direction}-${size}`]: typeof size === 'string' && size,
        });
        if (child === undefined || child === null) {
            return;
        }
        items.push(React.createElement(one_1.View, { key: index, className: itemCn, style: itemStyle }, child));
    });
    return items;
};
const Space = (props) => {
    const { size = 'small', direction = 'horizontal', align = direction === 'horizontal' ? 'center' : undefined, style, className, children, } = props;
    const cn = classnames_1.default(prefixCls, `${prefixCls}-${direction}`, {
        [`${prefixCls}-align-${align}`]: align,
    }, className);
    return (React.createElement(one_1.View, { className: cn, style: style }, renderItems(children, size, direction)));
};
exports.default = Space;
